exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-nouveautes-js": () => import("./../../../src/pages/nouveautes.js" /* webpackChunkName: "component---src-pages-nouveautes-js" */),
  "component---src-pages-recension-js": () => import("./../../../src/pages/recension.js" /* webpackChunkName: "component---src-pages-recension-js" */),
  "component---src-pages-recherche-js": () => import("./../../../src/pages/recherche.js" /* webpackChunkName: "component---src-pages-recherche-js" */)
}

